import type { UsageQueryParams } from "./get-usage";

export const billingKeys = {
  all: (organizationId: string) => ["billing", organizationId] as const,
  subscriptions: (organizationId: string) =>
    [...billingKeys.all(organizationId), "subscription"] as const,
  subscription: (organizationId: string) =>
    [...billingKeys.subscriptions(organizationId)] as const,
  customers: (organizationId: string) =>
    [...billingKeys.all(organizationId), "customer"] as const,
  customer: (organizationId: string) =>
    [...billingKeys.customers(organizationId)] as const,
  usages: (organizationId: string) =>
    [...billingKeys.all(organizationId), "usage"] as const,
  usage: (organizationId: string, params?: UsageQueryParams) =>
    [...billingKeys.usages(organizationId), params] as const,
  plans: (organizationId: string) =>
    [...billingKeys.all(organizationId), "plans"] as const,
  recentInvoices: (organizationId: string) =>
    [...billingKeys.all(organizationId), "recent-invoices"] as const,
  recentInvoice: (organizationId: string) =>
    [...billingKeys.recentInvoices(organizationId)] as const,
  scheduledChanges: (organizationId: string) =>
    [...billingKeys.all(organizationId), "scheduled-changes"] as const,
  scheduledChange: (organizationId: string) =>
    [...billingKeys.scheduledChanges(organizationId)] as const,
  upcomingInvoices: (organizationId: string) =>
    [...billingKeys.all(organizationId), "upcoming-invoice"] as const,
  upcomingInvoice: (organizationId: string) =>
    [...billingKeys.upcomingInvoices(organizationId)] as const,
};
